import React, {ReactElement} from 'react';
import {Text} from 'components/Text';
import {useKeyboardInput} from 'ui/utils/core';
import {daysBetween} from 'shared/utils/dateTime';
import {useBudgetStore} from 'ui/store/entities/Budget';

export const Income = (): ReactElement => {
  const input = useKeyboardInput();
  const budget = useBudgetStore();
  const daysLeft = daysBetween(budget.finishDate, budget.startDate);
  const perDay = Math.floor(input / daysLeft);

  return (
    <Text data-test='income'>
      Это +{perDay} на каждый день, включая сегодня. Делим всю сумму на остаток дней в бюджете.
    </Text>
  );
};
